import BasicRepository from "./basicRepository";
import Client from "../client";
import {
    EnvironmentResource,
    EnvironmentsSummaryResource,
    MachineResource,
    ResourceCollection,
    VariablesScopedToEnvironmentResponse,
} from "client/resources";

class EnvironmentRepository extends BasicRepository<EnvironmentResource> {
    constructor(client: Client) {
        super("Environments", client);
    }
    sort(order: string[]) {
        return this.client.put(this.client.getRootDocument().Links["EnvironmentSortOrder"], order);
    }
    variablesScopedOnlyToThisEnvironment(environment: EnvironmentResource): Promise<VariablesScopedToEnvironmentResponse> {
        return this.client.get<VariablesScopedToEnvironmentResponse>(environment.Links["SinglyScopedVariableDetails"]);
    }
    machines(args?: Partial<EnvironmentMachinesArgs>): Promise<ResourceCollection<MachineResource>> {
        return this.client.get<ResourceCollection<MachineResource>>(args.environment.Links["Machines"], args);
    }
    summary(args?: Partial<EnvironmentSummaryArgs>) {
        return this.client.get<EnvironmentsSummaryResource>(this.client.getRootDocument().Links["EnvironmentsSummary"], args);
    }
}

export type EnvironmentMachinesArgs = {
    environment: EnvironmentResource,
    skip: number,
    take: number,
    partialName: string,
    roles: string,
    isDisabled: boolean,
    healthStatuses: string,
    commStyles: string,
    tenantIds: string,
    tenantTags: string,
};

export type EnvironmentSummaryArgs = {
    ids: string,
    partialName: string,
    machinePartialName: string,
    roles: string,
    isDisabled: boolean,
    healthStatuses: string,
    commStyles: string,
    tenantIds: string,
    tenantTags: string,
    hideEmptyEnvironments: boolean,
};

export default EnvironmentRepository;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/repositories/environmentRepository.ts